'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.values = exports.ZRUSENY = exports.DEAKTIVOVANY = exports.AKTIVOVANY = exports.CEKA_NA_AKTIVACI = exports.REGISTROVANY = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _params;

exports.getCaption = getCaption;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2024-05-22T17:58:52Z                      #

// ##############################################################

/**
 * Stav účtu.
 */

var REGISTROVANY = exports.REGISTROVANY = 'REGISTROVANY';

var CEKA_NA_AKTIVACI = exports.CEKA_NA_AKTIVACI = 'CEKA_NA_AKTIVACI';

var AKTIVOVANY = exports.AKTIVOVANY = 'AKTIVOVANY';

var DEAKTIVOVANY = exports.DEAKTIVOVANY = 'DEAKTIVOVANY';

var ZRUSENY = exports.ZRUSENY = 'ZRUSENY';

/**
 * Seznam všech hodnot.
 */
var values = exports.values = [REGISTROVANY, CEKA_NA_AKTIVACI, AKTIVOVANY, DEAKTIVOVANY, ZRUSENY];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
var params = (_params = {}, (0, _defineProperty3.default)(_params, REGISTROVANY, { caption: '' }), (0, _defineProperty3.default)(_params, CEKA_NA_AKTIVACI, { caption: '' }), (0, _defineProperty3.default)(_params, AKTIVOVANY, { caption: '' }), (0, _defineProperty3.default)(_params, DEAKTIVOVANY, { caption: '' }), (0, _defineProperty3.default)(_params, ZRUSENY, { caption: '' }), _params);

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
function getCaption(value) {
  return params[value].caption;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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